// 🔄 (2026-11-05: a fix was live but the phone kept the old page) — checks every 5 minutes and when the tab comes back
// whether a newer build is deployed; if so, a bar asks to reload (and an idle page reloads by itself on return).
import { FC, useEffect, useState } from 'react';

const current = () => (document.querySelector('script[src*="/static/js/main."]') as HTMLScriptElement | null)?.src.match(/main\.([a-f0-9]+)\.js/)?.[1] || null;

const NewVersionBanner: FC = () => {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    const mine = current(); if (!mine) return;
    const check = async (onReturn = false) => {
      try {
        const html = await (await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' })).text();
        const live = html.match(/main\.([a-f0-9]+)\.js/)?.[1];
        if (live && live !== mine) {
          const typing = document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName);
          if (onReturn && !typing) window.location.reload(); else setStale(true);
        }
      } catch { /* offline */ }
    };
    const t = setInterval(() => check(false), 5 * 60 * 1000);
    const vis = () => { if (document.visibilityState === 'visible') check(true); };
    document.addEventListener('visibilitychange', vis);
    check(false);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', vis); };
  }, []);
  if (!stale) return null;
  return (
    <div onClick={() => window.location.reload()} style={{ position: 'fixed', bottom: 12, left: '50%', transform: 'translateX(-50%)', zIndex: 9999, background: '#1d4ed8', color: '#fff', borderRadius: 999, padding: '10px 18px', fontWeight: 800, fontSize: 14, boxShadow: '0 4px 16px rgba(0,0,0,.25)', cursor: 'pointer' }}>
      🔄 New version — tap to reload · نسخة جديدة، ضغط هنا
    </div>
  );
};
export default NewVersionBanner;
